import { useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";

const InputCheckBox = ({
  name,
  text,
  onCheckBoxChange,
  rules,
  className,
  checked,
}) => {
  const { register } = useFormContext();

  const [isChecked, setIsChecked] = useState(checked ?? false);

  // 🔥 FIX PENTING: sinkronkan prop -> state
  useEffect(() => {
    setIsChecked(checked ?? false);
  }, [checked]);

  const handleClick = () => {
    const next = !isChecked;
    setIsChecked(next);
    onCheckBoxChange(next);
  };

  return (
    <div className={`checkbox-item ${className}`} onClick={handleClick}>
      <input
        {...register(name, rules)}
        type="checkbox"
        checked={isChecked}
        value={text}
        readOnly
      />
      {text}
    </div>
  );
};

export default InputCheckBox;
